/**
 * Created by noOne on 04/09/2017.
 */

import Sprite3D from "./Sprite3D";

export default class Motive3D extends Sprite3D {
    constructor(type, moveSpeed) {
        super(type);

        /**
         * @type {number}
         * @private
         */
        this._moveSpeed = 8 || moveSpeed;
    }

    //todo - follow behaviour
    BEHAVE_FOLLOW() {
        //TweenMax.to(this, 3, {x: Common.player.x, y: Common.player.y, ease: Power0.easeNone});
    }

    BEHAVE_MOVETO(pos) {
        if (pos) {
            //calc distance for time calculations
            const d = Common.distance(this.x, this.y, pos.x, pos.y);
            const t = d / this._moveSpeed;

            TweenMax.to(this, t, {
                x: pos.x,
                y: pos.y,
                ease: Power0.easeNone,
                onComplete: ()=> {
                    this.view.visible = false;
                    const index = Common.sprites.indexOf(this);
                    Common.sprites.splice(index, 1);
                    Common.spriteHolder.removeChild(this.view);
                    this.view.destroy();
                }
            });
        }
        else {
            console.warn("no target position in MOVE_TO");
        }
    }

}